<template>
  <div class="aicg-container">
    <div class="header-section">
      <h1>{{ aicgData.title }}</h1>
      <p class="subtitle">{{ aicgData.subtitle }}</p>
    </div>
    
    <div class="projects-grid">
      <div class="column">
        <div v-for="project in oddProjects" :key="project.id" class="project-card">
          <div class="project-gallery">
            <a v-if="!project.images" :href="project.image" class="image-popup">
              <img :src="project.image" :alt="project.alt">
            </a>
            <template v-else>
              <a v-for="(img, idx) in project.images" :key="idx" :href="img" :class="['gallery-popup', 'gallery-' + project.id]" :style="idx > 0 ? 'display:none' : ''">
                <img v-if="idx === 0" :src="project.image" :alt="project.alt">
              </a>
            </template>
            <div class="gallery-overlay">
              <div class="zoom-btn" @click="openPopup(project)">
                <i class="fas fa-search-plus"></i>
              </div>
              <span v-if="project.images && project.images.length > 1" class="gallery-count">
                <i class="fas fa-images"></i> {{ project.images.length }}
              </span>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Client:</span>
                <span class="value">{{ project.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div v-for="project in evenProjects" :key="project.id" class="project-card">
          <div class="project-gallery">
            <a v-if="!project.images" :href="project.image" class="image-popup">
              <img :src="project.image" :alt="project.alt">
            </a>
            <template v-else>
              <a v-for="(img, idx) in project.images" :key="idx" :href="img" :class="['gallery-popup', 'gallery-' + project.id]" :style="idx > 0 ? 'display:none' : ''">
                <img v-if="idx === 0" :src="project.image" :alt="project.alt">
              </a>
            </template>
            <div class="gallery-overlay">
              <div class="zoom-btn" @click="openPopup(project)">
                <i class="fas fa-search-plus"></i>
              </div>
              <span v-if="project.images && project.images.length > 1" class="gallery-count">
                <i class="fas fa-images"></i> {{ project.images.length }}
              </span>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Client:</span>
                <span class="value">{{ project.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HomeButton />
</template>

<script>
import $ from 'jquery'
import 'magnific-popup/dist/jquery.magnific-popup.js'
import 'magnific-popup/dist/magnific-popup.css'
import '@fortawesome/fontawesome-free/css/all.css'
import HomeButton from '@/components/common/HomeButton.vue'

export default {
  name: 'AICG',
  components: {
    HomeButton
  },
  data() {
    return {
      aicgData: {
        title: "AI Generated Content",
        subtitle: "Exploring creative boundaries with AI tools",
        projects: [
          {
            id: 1,
            image: require('@/assets/img/AICG/1.png'), 
            alt: "Film Style Illustration",
            title: "Film Style Illustration",
            description: "Keep the film-style illustration style, in which a character sits under a street lamp with their head resting on their knees, eyes half closed.",
            techStack: ["Jimeng AI"],
            client: "Personal Concept",
            year: "2026"
          },
          {
            id: 2,
            image: require('@/assets/img/AICG/2.png'), 
            alt: "Winter Starry Sky",
            title: "Winter Starry Sky",
            description: "Five girls sitting and looking up at the beautiful starry sky in winter, with light snow falling. The perspective is from the girls' feet.",
            techStack: ["Jimeng AI"],
            client: "Personal Concept",
            year: "2026"
          },
          {
            id: 3,
            image: require('@/assets/img/AICG/3.png'), 
            alt: "Cozy Cabin Kitchen",
            title: "Cozy Cabin Kitchen",
            description: "Cozy open-plan cabin interior illustration, focusing on the lower-level kitchen area with European-style solid wood cabinets and neatly arranged golden kitchenware.",
            techStack: ["Jimeng AI"],
            client: "Personal Concept",
            year: "2026"
          },
          {
            id: 4,
            image: require('@/assets/img/AICG/4.png'), 
            alt: "Cozy Cabin Dining Area",
            title: "Cozy Cabin Dining Area",
            description: "Cozy open-plan cabin interior illustration, focusing on the lower-level dining area with a small solid wood dining table, three chairs, and a vase of roses.",
            techStack: ["Jimeng AI"],
            client: "Personal Concept",
            year: "2026"
          },
          {
            id: 5,
            image: require('@/assets/img/AICG/5.png'), 
            alt: "Cats Dining at Retro Restaurant",
            title: "Cats Dining at Retro Restaurant",
            description: "Anthropomorphic cats of different professions having dinner at a vintage retro restaurant. Fresh, cute, and minimalist illustration style inspired by artist Yeoniu C.",
            techStack: ["Jimeng AI"],
            client: "Personal Concept",
            year: "2026"
          },
          {
            id: 6,
            image: require('@/assets/img/AICG/6.png'), 
            alt: "Gemini Generated Artwork 1",
            title: "Creative Visualization I",
            description: "An AI-generated visual concept exploring complex themes through advanced prompt engineering.",
            techStack: ["Gemini AI"],
            client: "Company Needs",
            year: "2026"
          },
          {
            id: 7,
            image: require('@/assets/img/AICG/7.png'), 
            alt: "Gemini Generated Artwork 2",
            title: "Creative Visualization II",
            description: "A digital artwork generated utilizing Gemini AI to render imaginative compositions.",
            techStack: ["Gemini AI"],
            client: "Company Needs",
            year: "2026"
          },
          {
            id: 8,
            image: require('@/assets/img/AICG/8.png'), 
            alt: "Gemini Generated Artwork 3",
            title: "Creative Visualization III",
            description: "Exploration of aesthetic designs and structural elements through generative AI.",
            techStack: ["Gemini AI"],
            client: "Company Needs",
            year: "2026"
          },
          {
            id: 9,
            image: require('@/assets/img/AICG/9.png'), 
            alt: "Gemini Generated Artwork 4",
            title: "Creative Visualization IV",
            description: "A nuanced visual study combining abstract and concrete ideas via generative models.",
            techStack: ["Gemini AI"],
            client: "Company Needs",
            year: "2026"
          }
        ]
      }
    }
  },
  computed: {
    sortedProjects() {
      return [...this.aicgData.projects].sort((a, b) => a.id - b.id);
    },
    oddProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 1);
    },
    evenProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 0);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Single image popup
      $('.image-popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true
        },
        zoom: {
          enabled: true,
          duration: 300
        },
        callbacks: {
          open: function() {
            history.pushState({ popup: true }, '');
          },
          close: function() {
            if (history.state && history.state.popup) {
              history.back();
            }
          }
        }
      });

      // Gallery popup for projects with multiple images
      this.aicgData.projects.forEach(project => {
        if (project.images && project.images.length > 1) {
          $(`.gallery-${project.id}`).magnificPopup({
            type: 'image',
            gallery: {
              enabled: true,
              navigateByImgClick: true,
              preload: [0, 1],
              tCounter: '<span class="mfp-counter">%curr% / %total%</span>'
            },
            closeOnContentClick: false,
            closeBtnInside: false,
            fixedContentPos: true,
            mainClass: 'mfp-no-margins mfp-with-zoom mfp-img-mobile',
            image: {
              verticalFit: true
            },
            callbacks: {
              open: function() {
                history.pushState({ popup: true }, '');
              },
              close: function() {
                if (history.state && history.state.popup) {
                  history.back();
                }
              }
            }
          });
        }
      });

      window.addEventListener('popstate', this.handlePopState);
    });
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    openPopup(project) {
      if (project.images && project.images.length > 1) {
        $(`.gallery-${project.id}`).first().trigger('click');
      } else {
        const $link = $('.image-popup').first();
        $link.attr('href', project.image);
        $link.trigger('click');
      }
    },
    handlePopState() {
      if ($.magnificPopup.instance.isOpen) {
        $.magnificPopup.close();
      }
    }
  }
}
</script>

<style scoped>
.aicg-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2rem;
}

.header-section h1 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
}

.projects-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 992px) {
  .header-section h1 {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    padding: 0;
  }
  
  .aicg-container {
    padding: 1rem 0.5rem;
  }
  
  .header-section {
    margin-bottom: 1.5rem;
  }
  
  .header-section h1 {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .header-section h1 {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
  
  .project-info h3 {
    font-size: 1.2rem;
  }
  
  .project-info p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .tech-stack span {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  
  .label {
    font-size: 0.8rem;
  }
  
  .value {
    font-size: 0.9rem;
  }
}

.project-card {
  break-inside: avoid;
  margin-bottom: 1.5rem;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 100%;
}

.project-card:hover {
  transform: translateY(-5px);
}

.project-gallery {
  position: relative;
  overflow: hidden;
}

.project-gallery img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-gallery:hover .gallery-overlay {
  opacity: 1;
}

.zoom-btn {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.zoom-btn:hover {
  background: white;
  transform: scale(1.1);
}

.zoom-btn i {
  color: #333;
  font-size: 1.2rem;
}

.project-info {
  padding: 1.5rem;
}

.project-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
}

.project-info p {
  color: #666;
  margin-bottom: 1rem;
}

.tech-stack {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.tech-stack span {
  background: #f0f0f0;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  color: #555;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.9rem;
  color: #666;
}

.value {
  font-weight: 500;
  color: #333;
}

.image-popup,
.gallery-popup {
  display: block;
  cursor: pointer;
}

.gallery-count {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  padding: 0.3rem 0.6rem;
  border-radius: 15px;
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  z-index: 5;
}

.gallery-count i {
  font-size: 0.9rem;
}

/* 触摸设备优化 */
@media (hover: none) {
  .gallery-overlay {
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
  }
  
  .project-card:active {
    transform: translateY(-5px);
  }
}
</style>
